/**
 * Synchronisiert die Bestellnotiz mit dem Warenkorb: Entfernt Notiz-Blöcke für Konfigurationen,
 * die keine Line-Items mehr im Warenkorb haben (z. B. nach manuellem Entfernen im Warenkorb).
 * Muss mit dem Format in page-konfigurator.js (NOTE_HEADER_LINE, KONFIGURATION x) übereinstimmen.
 */
(function () {
  const NOTE_HEADER_LINE = '═══════════════════';
  const NOTE_SEPARATOR_REGEX = /═+\nKONFIGURATION /;

  function getConfigNumbersFromCart(items) {
    const configNumbersInCart = new Set();
    (items || []).forEach((item) => {
      const n = item.properties && item.properties['Konfiguration'];
      if (n !== undefined && n !== null) {
        const num = parseInt(String(n), 10);
        if (!isNaN(num)) configNumbersInCart.add(num);
      }
    });
    return configNumbersInCart;
  }

  function getBlockConfigNumber(block) {
    const part = String(block).replace(/^\s+|\s+$/g, '');
    const firstLineEnd = part.indexOf('\n');
    const numStr = firstLineEnd === -1 ? part : part.slice(0, firstLineEnd).trim();
    return parseInt(numStr, 10);
  }

  function filterNoteToConfigNumbers(note, configNumbersToKeep) {
    const trimmed = (note || '').trim();
    if (!trimmed) return '';

    const parts = trimmed.split(NOTE_SEPARATOR_REGEX);
    if (parts.length < 2) return '';

    const kept = [];
    for (let i = 1; i < parts.length; i++) {
      const part = parts[i].replace(/^\s+|\s+$/g, '');
      const blockNum = getBlockConfigNumber(part);
      if (!isNaN(blockNum) && configNumbersToKeep.has(blockNum)) {
        kept.push(`${NOTE_HEADER_LINE}\nKONFIGURATION ${part}`);
      }
    }
    return kept.join('\n\n');
  }

  function removeConfigFromNote(note, configGroup) {
    const trimmed = (note || '').trim();
    if (!trimmed) return '';

    const parts = trimmed.split(NOTE_SEPARATOR_REGEX);
    if (parts.length < 2) return trimmed;

    const prefix = (parts[0] || '').trim();
    const blocks = [];
    for (let i = 1; i < parts.length; i++) {
      const part = parts[i].replace(/^\s+|\s+$/g, '');
      const blockNum = getBlockConfigNumber(part);
      if (!isNaN(blockNum) && String(blockNum) === String(configGroup)) {
        continue;
      }
      blocks.push(`${NOTE_HEADER_LINE}\nKONFIGURATION ${part}`);
    }

    if (prefix && blocks.length > 0) return [prefix, ...blocks].join('\n\n');
    if (prefix && blocks.length === 0) return prefix;
    return blocks.join('\n\n');
  }

  function updateConfigQuantityInNote(note, configGroup, nextQuantity) {
    const trimmed = (note || '').trim();
    if (!trimmed) return '';

    const parts = trimmed.split(NOTE_SEPARATOR_REGEX);
    if (parts.length < 2) return trimmed;

    const prefix = (parts[0] || '').trim();
    const blocks = [];
    for (let i = 1; i < parts.length; i++) {
      let part = parts[i].replace(/^\s+|\s+$/g, '');
      const blockNum = getBlockConfigNumber(part);
      if (!isNaN(blockNum) && String(blockNum) === String(configGroup)) {
        if (/^Anzahl:\s.*$/m.test(part)) {
          part = part.replace(/^Anzahl:\s.*$/m, `Anzahl: ${nextQuantity}`);
        }
      }
      blocks.push(`${NOTE_HEADER_LINE}\nKONFIGURATION ${part}`);
    }

    if (prefix) return [prefix, ...blocks].join('\n\n');
    return blocks.join('\n\n');
  }

  async function syncKonfiguratorOrderNote() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const note = (cart.note || '').trim();
      const items = cart.items || [];

      if (!note) return;

      const configNumbersInCart = getConfigNumbersFromCart(items);
      const newNote = filterNoteToConfigNumbers(note, configNumbersInCart);
      if (newNote === note) return;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: newNote })
      });
    } catch (e) {
      console.warn('Konfigurator: Order-Note-Sync fehlgeschlagen', e);
    }
  }

  if (typeof window !== 'undefined') {
    window.syncKonfiguratorOrderNote = syncKonfiguratorOrderNote;
    window.konfiguratorOrderNote = {
      NOTE_HEADER_LINE,
      getConfigNumbersFromCart,
      filterNoteToConfigNumbers,
      removeConfigFromNote,
      updateConfigQuantityInNote,
    };
  }
})();
